/**
 * Convert absolute pixel coordinates to relative (0–1) coordinates
 * @param {number} x1 - Top-left X in pixels
 * @param {number} y1 - Top-left Y in pixels
 * @param {number} x2 - Bottom-right X in pixels
 * @param {number} y2 - Bottom-right Y in pixels
 * @param {number} width - Image display width in pixels
 * @param {number} height - Image display height in pixels
 * @returns {number[]} [relX1, relY1, relX2, relY2] each 0–1
 */
export function toRelativeBbox(x1, y1, x2, y2, width, height) {
  return [
    Math.max(0, Math.min(1, x1 / width)),
    Math.max(0, Math.min(1, y1 / height)),
    Math.max(0, Math.min(1, x2 / width)),
    Math.max(0, Math.min(1, y2 / height)),
  ];
}

/**
 * Normalize bbox so (x1,y1) is always top-left and (x2,y2) is bottom-right
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @returns {number[]} [minX, minY, maxX, maxY]
 */
export function normalizeBbox(x1, y1, x2, y2) {
  return [
    Math.min(x1, x2),
    Math.min(y1, y2),
    Math.max(x1, x2),
    Math.max(y1, y2),
  ];
}
